import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
// Components for Each Section
const TargetAudience = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [brandAudience, setBrandAudience] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchBrandAudience = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-Audience/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setBrandAudience(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchBrandAudience();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handlebrandAudienceChange = (e) => {
        const { name, value } = e.target;
        setBrandAudience((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-TargetAudience/${brandAudience.target_audience_id}/${brandId}`,
                brandAudience,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchBrandAudience();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Target Audience
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {brandAudience?.updatedAt ? new Date(brandAudience.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                   
                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <p className="my-2 px-3 text-warning">Primary Target Audience <small className="text-warning">(Demographics & Psychographics):</small></p>
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Age Group</th>
                                <td>
                                    {brandAudience?.primary_age_group || "Not Specified"}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Gender</th>
                                <td>
                                    {brandAudience?.primary_gender || "Not Specified"}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Location</th>
                                <td>
                                    {brandAudience?.primary_location || "Not Specified"}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Interests & Hobbies</th>
                                <td>
                                    {brandAudience?.primary_interests_hobbies || "Not Specified"}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Lifestyle & Spending Habits:</th>
                                <td>
                                    {brandAudience?.primary_lifestyle_spending || "Not Specified"}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Pain Points & Problems the Brand Solves:</th>
                                <td>
                                    {brandAudience?.primary_pain_points || "Not Specified"}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <p className="my-2 px-3 text-warning">Secondary Target Audience<small className="text-warning"> Buyer Persona(s)
                        (Detailed audience archetypes, if available):</small>  {brandAudience?.secondary_target_audience || "Not Specified"}</p>
                    <Table className="brandTable">

                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Target Audience"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row style={{height: '70vh', overflowY: 'auto'}}>
                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Age Group</Form.Label>
                        <Form.Control type="text" name="primary_age_group" value={brandAudience.primary_age_group} onChange={handlebrandAudienceChange} />
                    </Col>

                    <Col md={6} lg={6} className="mb-3 px-1">
                        <Form.Label>Gender</Form.Label>
                        <Form.Control type="text" name="primary_gender" value={brandAudience.primary_gender} onChange={handlebrandAudienceChange} />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Location</Form.Label>
                        <Form.Control as="textarea" name="primary_location" value={brandAudience.primary_location} onChange={handlebrandAudienceChange} rows={3} className="h-auto"/>
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Interests & Hobbies</Form.Label>
                        <Form.Control as="textarea" name="primary_interests_hobbies" value={brandAudience.primary_interests_hobbies} onChange={handlebrandAudienceChange} rows={3} className="h-auto"/>
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Lifestyle & Spending Habits</Form.Label>
                        <Form.Control as="textarea" name="primary_lifestyle_spending" value={brandAudience.primary_lifestyle_spending} onChange={handlebrandAudienceChange} rows={3} className="h-auto"/>
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Pain Points & Problems the Brand Solves</Form.Label>
                        <Form.Control as="textarea" name="primary_pain_points" value={brandAudience.primary_pain_points} onChange={handlebrandAudienceChange} rows={3} className="h-auto"/>
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Secondary Target Audience</Form.Label>
                        <Form.Control as="textarea" name="secondary_target_audience" value={brandAudience.secondary_target_audience} onChange={handlebrandAudienceChange} rows={5} className="h-auto"/>
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default TargetAudience;